import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../actions';
import Checkbox from 'material-ui/Checkbox';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

class FileSelectorRow extends Component {

    constructor(props) {
        super(props);
        this.state = {
           checked: false
        };
        if (props.header) {
            this.select = "";
            this.type = "Type";
            this.name = "Name";
            this.size = "Size";
        } else {
            this.type = this.convertTypeToText(props.file.type);
            this.name = props.file.name;
            this.size = parseInt(props.file.size/1000,0) + " KB";
        }
    }

    componentWillReceiveProps (nextProps){
        if (!nextProps.header) {
            if (this.name !== nextProps.file.name) {
                this.setState ({checked: false});
            }
        }
    }

    convertTypeToText = (type) => {
        var typestring = String(type);
        if (typestring.includes('pdf')){
            return 'pdf';
        } else if (typestring.includes('ms-excel')){
            return 'xls';
        } else if (typestring.includes('msword')){
            return 'doc';
        } else if (typestring.includes('ms-powerpoint')){
            return 'preso';
        } else if (typestring.includes('image')){
            return 'img';
        } else if (typestring.includes('video')){
            return 'vid';
        } else if (typestring.includes('text')){
            return 'txt';
        } else if (typestring.includes('zip')){
            return 'zip';
        } else {
            return 'file';
        }
    }

    addHeaderStyle = () => {
        if (this.props.header){
            return (" fsr-header")
        } else {
            return (" fsr-cell")
        }
    }

    onChange = (e) => {
        this.props.checkBoxTicked(this.props.index);
        this.setState({checked: !this.state.checked});
    }

    renderCheckBox = () => {
        if (!this.props.header){
            return (
                <div className="fsr-checkbox-container">
                    <MuiThemeProvider>
                    <Checkbox
                        checked={this.state.checked}
                        onCheck={this.onChange}
                    />
                    </MuiThemeProvider>
                </div>
            );
        }
    }

    setText = () => {
        if (this.props.header) {
            this.select = "";
            this.type = "Type";
            this.name = "Name";
            this.size = "Size";
        } else {
            this.type = this.convertTypeToText(this.props.file.type);
            this.name = this.props.file.name;
            this.size = parseInt(this.props.file.size/1000,0) + " KB";
        }
    }

    onClick = () => {
        this.props.downloadFile(this.props.file);
    }

    render() {
        this.setText();
        return (
            <div className="fsr-container">
                <div className={"fsr-select fsr-centre"+this.addHeaderStyle()}> {this.renderCheckBox()} </div>
                <div className={"fsr-type fsr-centre"+this.addHeaderStyle()}> {this.type} </div>
                <div onClick={this.onClick} className={"fsr-name fsr-left"+this.addHeaderStyle()}> {this.name} </div>
                <div className={"fsr-size fsr-centre"+this.addHeaderStyle()}> {this.size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} </div>
            </div>
        );
    }
  }

  function mapStateToProps(state) {
      return { files: state.app.files,
                fileloading: state.app.fileloading };
  }

  export default connect(mapStateToProps, actions)(FileSelectorRow);



// WEBPACK FOOTER //
// ./src/components/fileselectorrow.js